module.exports = __webpack_public_path__ + "img/google.ff629c02.png";